import React from 'react'
import { Helmet } from 'react-helmet-async'

import { getQueryParamsFromHash, parsePermittedQueryParams } from '@domain-group/javascript-utils'

import { Box, Button, Columns } from '@domain-group/suit-theme'

import PageHeader from '@components/PageHeader'

import useGeoCountry from '@hooks/useGeoCountry'

import generateTabBarItems from '../../utils/generateTabBarItems'

interface PageLayoutProps {
  activeTabBarItemKey: string,
  children: React.ReactNode,
  entityPayload: ReturnType<typeof useGeoCountry>,
}

const PageLayout = (props: PageLayoutProps) => {
  const { activeTabBarItemKey, children, entityPayload } = props

  const {
    geoCountry,
    urls: { geoCountriesIndexUrl },
  } = entityPayload

  const { redirect }: { redirect?: string } = parsePermittedQueryParams(getQueryParamsFromHash(), ['redirect'])

  return (
    <>
      <Helmet>
        <title>Edit Country | Realhub</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={redirect || geoCountriesIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey={activeTabBarItemKey}
        // @ts-expect-error TS2345
        tabBarItems={generateTabBarItems(geoCountry)}
        title="Edit Country"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          {children}
        </Columns>
      </Box>
    </>
  )
}

export default PageLayout
